import { connectColors } from '@/theme/colors';
import { Flex, Text } from '@lego/klik-ui';
import type { ReactNode } from 'react';
import { DEFAULT_PAGE_MAX_WIDTH } from '../page-wrapper/page-layout';

export type PageHeaderProps = {
  title?: string | ReactNode;
  actions?: ReactNode; // right side (buttons)
};

const PageHeader = ({ title, actions }: PageHeaderProps) => {
  if (!title && !actions) return null;

  return (
    <Flex
      justifyContent="center"
      minHeight="48px"
      py="8px"
      background={connectColors.core.blue[50]}
      flexDir="column"
    >
      <Flex
        paddingX="16px"
        width="100%"
        maxWidth={DEFAULT_PAGE_MAX_WIDTH}
        justify="space-between"
        align="center"
        margin="0 auto"
      >
        {typeof title === 'string' ? (
          <Text
            fontSize="md"
            fontWeight="medium"
            color={connectColors.core.offBlack}
          >
            {title}
          </Text>
        ) : (
          title
        )}

        {actions}
      </Flex>
    </Flex>
  );
};

export default PageHeader;
